import React, { memo, useCallback } from 'react';
import SecretDetailSingleton from './SecretDetailSingleton';
import SecretFormSingleton from './SecretFormSingleton';

const SecretPanel = memo(({ 
  selectedItem, 
  showForm, 
  handleUnselectItem, 
  handleEditItem, 
  handleDeleteItem, 
  handleDeleteConfirmation,
  handleSecretAdd,
  setShowForm 
}) => {
  const handleCloseForm = useCallback(() => {
    setShowForm(false);
    handleUnselectItem();
  }, [setShowForm, handleUnselectItem]);

  const handleEditClick = useCallback(() => {
    setShowForm(true);
  }, [setShowForm]);

  const handleDeleteClick = useCallback(() => {
    handleDeleteConfirmation(selectedItem);
  }, [handleDeleteConfirmation, selectedItem]);
  
  if (showForm) {
    return (
      <SecretFormSingleton
        editingItem={selectedItem}
        closeForm={handleCloseForm}
        onSecretAdd={handleSecretAdd}
      />
    );
  }

  return (
    <SecretDetailSingleton
      selectedItem={selectedItem}
      handleUnselectItem={handleUnselectItem}
      handleEditItem={handleEditClick}
      handleDeleteItem={handleDeleteClick}
    />
  );
});

SecretPanel.displayName = 'SecretPanel';

export default SecretPanel;
